import { render } from "./PasswordChange.vue?vue&type=template&id=2cf0816e&scoped=true"
import script from "./PasswordChange.vue?vue&type=script&lang=js"
export * from "./PasswordChange.vue?vue&type=script&lang=js"

import "./PasswordChange.vue?vue&type=style&index=0&id=2cf0816e&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf0816e"]])

export default __exports__